import { render, staticRenderFns } from "./batchmodify.vue?vue&type=template&id=532c7132&scoped=true&"
import script from "./batchmodify.vue?vue&type=script&lang=js&"
export * from "./batchmodify.vue?vue&type=script&lang=js&"
import style0 from "./batchmodify.vue?vue&type=style&index=0&id=532c7132&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c7132",
  null
  
)

export default component.exports